// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal-window {
  box-shadow: var(--window-box-shadow);
  pointer-events: auto;
  z-index: 9999;
  width: 80%;
  height: 80%;
  margin-bottom: 0;
}

@media (width >= 768px) {
  .modal-window {
    height: 50%;
  }
}

@media (width >= 1408px) {
  .modal-window {
    width: 70%;
  }
}

@media (width >= 1600px) {
  .modal-window {
    width: 60%;
  }
}

.modal-window .box-body {
  flex-direction: row;
  display: flex;
}

.modal-window .box-header .box-title {
  margin-top: 2px !important;
  margin-bottom: 2px !important;
}
`, "",{"version":3,"sources":["webpack://./home/autoboss/ipfabric-product/services/frontend/app/components/ModalWindow/ModalWindow.css","webpack://./services/frontend/app/components/ModalWindow/ModalWindow.css"],"names":[],"mappings":"AADA;ECEE,oCAAoC;EACpC,oBAAoB;EACpB,aAAa;EACb,UAAU;EACV,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE;IACE,WAAW;EACb;AACF;;AAEA;EACE;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,UAAU;EACZ;AACF;;AAEA;EACE,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,0BAA0B;EAC1B,6BAA6B;AAC/B","sourcesContent":[".modal-window {\n  box-shadow: var(--window-box-shadow);\n  height: 80%;\n  margin-bottom: 0;\n  pointer-events: auto;\n  width: 80%;\n  z-index: 9999;\n}\n\n  @media (min-width: 768px) {.modal-window {\n    height: 50%\n}\n  }\n\n  @media (min-width: 1408px) {.modal-window {\n    width: 70%\n}\n  }\n\n  @media (min-width: 1600px) {.modal-window {\n    width: 60%\n}\n  }\n\n  .modal-window .box-body {\n    display: flex;\n    flex-direction: row;\n  }\n\n  .modal-window .box-header .box-title {\n    margin-bottom: 2px !important;\n    margin-top: 2px !important;\n  }\n",".modal-window {\n  box-shadow: var(--window-box-shadow);\n  pointer-events: auto;\n  z-index: 9999;\n  width: 80%;\n  height: 80%;\n  margin-bottom: 0;\n}\n\n@media (width >= 768px) {\n  .modal-window {\n    height: 50%;\n  }\n}\n\n@media (width >= 1408px) {\n  .modal-window {\n    width: 70%;\n  }\n}\n\n@media (width >= 1600px) {\n  .modal-window {\n    width: 60%;\n  }\n}\n\n.modal-window .box-body {\n  flex-direction: row;\n  display: flex;\n}\n\n.modal-window .box-header .box-title {\n  margin-top: 2px !important;\n  margin-bottom: 2px !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
